import hljs from "highlight.js";
import Confetti from "../confetti.min.js";

declare const mapboxgl: any;

export const views = {
  firstResponder: (el: HTMLElement, _: unknown) => {
    el.focus();
  },

  places: (el: HTMLElement, markers: [number, number][]) => {
    mapboxgl.accessToken =
      "pk.eyJ1IjoiZG5pdHphIiwiYSI6ImNsZWIyY3ZzaTE0cjUzdm4xdnZ6czRlYjUifQ.FRETOXYRID6T2IoB7qqRLg";
    const map = new mapboxgl.Map({
      container: el,
      style: "mapbox://styles/mapbox/streets-v11",
      maxZoom: 8,
    });

    const bounds = new mapboxgl.LngLatBounds(markers[0], markers[0]);
    for (let i = 0; i < markers.length; i++) {
      bounds.extend(markers[i]);
    }
    map.fitBounds(bounds, { padding: 60 });

    for (let i = 0; i < markers.length; i++) {
      const marker = markers[i];
      const markerEl = document.createElement("div");
      markerEl.className = "map-marker";
      new mapboxgl.Marker(markerEl).setLngLat(marker).addTo(map);
    }
  },

  tada: (el: HTMLElement, _: unknown) => {
    const confetti = new Confetti(el.id);
    confetti.setCount(200);
    confetti.setSize(2);
    confetti.setPower(20);
    confetti.setFade(true);
    confetti.destroyTarget(false);

    for (let i = 1; i < 4; i++) {
      confetti.setPower(20 * i);
      setTimeout(() => {
        el.dispatchEvent(new Event("click"));
      }, 500 * i);
    }
  },

  postLength: (_: HTMLElement, attrs: {
    blueskyIntegrations: string[];
    mastodonIntegrations: string[];
    postNameSelector: string;
    target: string;
    warningClass: string;
  }) => {
    const blueskySelectors = attrs.blueskyIntegrations.map(
      (idx) => `bluesky-integration-${idx}`,
    );
    const mastodonSelectors = attrs.mastodonIntegrations.map(
      (idx) => `mastodon-integration-${idx}`,
    );

    document.addEventListener("tiptap:update", (e) => {
      const text = (e as CustomEvent<{ text: string }>).detail.text;

      if ((document.querySelector(attrs.postNameSelector) as HTMLInputElement)?.value !== "") {
        document
          .querySelectorAll(attrs.target)
          .forEach((el) => el.classList.add("hidden"));
      } else {
        document
          .querySelectorAll(`${attrs.target}.hidden`)
          .forEach((el) => el.classList.remove("hidden"));
      }

      const postLength = text.length;

      blueskySelectors.forEach((selector) => {
        document
          .querySelectorAll(`[for=${selector}] ${attrs.target}`)
          .forEach((el) => {
            (el as HTMLElement).innerText = `(${postLength} / 300)`;
            if (postLength >= 300) {
              el.classList.add(attrs.warningClass);
            } else {
              el.classList.remove(attrs.warningClass);
            }
          });
      });

      mastodonSelectors.forEach((selector) => {
        document
          .querySelectorAll(`[for=${selector}] ${attrs.target}`)
          .forEach((el) => {
            (el as HTMLElement).innerText = `(${postLength} / 500)`;
            if (postLength >= 500) {
              el.classList.add(attrs.warningClass);
            } else {
              el.classList.remove(attrs.warningClass);
            }
          });
      });
    });
  },
};

export function applyFormattingToPreBlocks() {
  const preElements = document.querySelectorAll("pre");
  preElements.forEach(function (preElement) {
    const regex = /(?!lang\-\\w\*)lang-\w*\W*/gm;
    const codeElement = document.createElement("code");
    if (preElement.childNodes.length > 1) {
      console.error(
        "<pre> element contained nested inline elements (probably styling) and could not be processed. Please remove them and try again.",
      );
    }
    preElement.classList.add("p-0");
    const preElementTextNode = preElement.removeChild(preElement.firstChild!);
    let language = preElementTextNode.textContent?.match(regex) ?? null;
    if (language) {
      const lang = language[0].toString().trim();
      preElementTextNode.textContent = (preElementTextNode.textContent ?? "").replace(lang, "");
      codeElement.classList.add(lang, "line-numbers");
    }
    codeElement.append(preElementTextNode);
    preElement.append(codeElement);
  });

  hljs.highlightAll();
}
